import { DarkPopup } from '@elements/Popup';
import { InfoIcon, MuteLabel } from '../styles/common';

export function FormLabel({ label, info_tooltip }) {
  return (
    <MuteLabel>
      {label}
      {info_tooltip && (
        <DarkPopup trigger={<InfoIcon />}>{info_tooltip}</DarkPopup>
      )}
    </MuteLabel>
  );
}
